module.exports = __webpack_public_path__ + "media/promo/hochland/images/knife-9e5ca091fac53f0a8fb84fcd6941db70.png";